import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopupModule } from '../../core/libraries/popup/popup.module';
import { ForgotPasswordModule } from '../../features/auth/forgot-password/forgot-password.module';
import { LandingModule } from '../../features/auth/landing/landing.module';
import { LoginModule } from '../../features/auth/login/login.module';
import { LogoutModule } from '../../features/auth/logout/logout.module';
import { PrivacyPolicyModule } from '../../features/auth/privacy-policy/privacy-policy.module';
import { SignupModule } from '../../features/auth/signup/signup.module';
import { VerifyEmailModule } from '../../features/auth/verify-email/verify-email.module';
import { VerifyResetPasswordModule } from '../../features/auth/verify-reset-password/verify-reset-password.module';
import { AuthLayoutRoutingModule } from './auth-layout-routing.module';
import { AuthLayoutComponent } from './auth-layout.component';

@NgModule({
    declarations: [AuthLayoutComponent],
    imports: [
        AuthLayoutRoutingModule,
        CommonModule,
        ForgotPasswordModule,
        LandingModule,
        LoginModule,
        LogoutModule,
        PopupModule,
        SignupModule,
        VerifyEmailModule,
        VerifyResetPasswordModule,
        PrivacyPolicyModule,
    ],
})
export class AuthLayoutModule {}
